export default [
    {path: ':trial_station_id/:year/:season_id'},
]